import { useHistory, useLocation } from "react-router-dom";
import { ServicesTypesComponentLoad } from "../types/ApplicationTypes";
import { useServiceUserCreationCtx } from "../context/ServiceUserCreationContext";

export function usePersonFormBackNavigation(
  isInvalidAddressModalRedirect?: boolean
) {
  const { search, pathname } = useLocation();
  const history = useHistory();
  const query = new URLSearchParams(search);

  const {
    pageTypeCtx,
    whoWillUseServicesCtx,
    contactTcCtx,
  } = useServiceUserCreationCtx();
  const [, setPageType] = pageTypeCtx;
  const [whoWillUseServices] = whoWillUseServicesCtx;
  const [, setContacts] = contactTcCtx;

  function navigateBack() {
    const source = query.get("source");
    const isFromWelcome = pathname.includes("Welcome");
    const redirectTo = (pathName: string) => history.push(pathName);

    if (
      isInvalidAddressModalRedirect &&
      whoWillUseServices === "Profile" &&
      source !== "Dashboard"
    ) {
      setPageType(ServicesTypesComponentLoad.AddAnotherServiceUser);
    } else if (source === "Dashboard") {
      isFromWelcome
        ? setPageType(ServicesTypesComponentLoad.Welcome)
        : redirectTo("/DashBoard");
    } else if (source === "ScheduleService") {
      isFromWelcome
        ? setPageType(ServicesTypesComponentLoad.Welcome)
        : redirectTo("/DashBoard/ScheduleService");
    } else {
      setPageType(ServicesTypesComponentLoad.Welcome);
    }

    setContacts([]);
  }

  return { navigateBack };
}
